import headerScroll from '../partials/header'
import Swiper from 'swiper'

export default {
  init() {
    window.onscroll = headerScroll;

    // eslint-disable-next-line
    let reportSlider = new Swiper('.report-slider', {
      slidesPerView: 1,
      scrollbar: {
        el: '.swiper-scrollbar',
        hide: false,
        draggable: true,
        // dragSize: 74,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    })

    // Tabs Actions
    $('.sticky-nav__menu button').on('click', function () {
      if (window.innerWidth > 991) {
        $('.sticky-nav__menu button').removeClass('active');
        $(this).addClass('active');
      }
      else {
        if ($(this).hasClass('active')) {
          $(this).parent().parent().toggleClass('slide');
        }
        else {
          $('.sticky-nav__menu button').removeClass('active');
          $(this).parent().parent().removeClass('slide');
          $('.sticky-nav__menu li').removeClass('first');
          $(this).parent().addClass('first');
          $(this).addClass('active');
        }
      }
    });

    //Mobile Actions
    if (window.innerWidth < 992) {
      let initTabMenu = 10000;
      let containerWidth = 0;
      let nextSection = 10000;

      //Init
      setTimeout(function () {
        initTabMenu = $('.sticky-nav__menu').offset().top;
        containerWidth = $('.container').width();
        nextSection = $('.sticky-nav').next().offset().top;
        console.log(nextSection)
      }, 500);

      $(window).on('scroll', function () {
        if ((window.pageYOffset + 106) >= initTabMenu) {
          $('.sticky-nav__menu').addClass('fixed');
          $('.sticky-nav__menu li').width(containerWidth);
        }
        else {
          $('.sticky-nav__menu').removeClass('fixed');
          $('.sticky-nav__menu li').width('100%');
        }

        if ((window.pageYOffset + 156) >= nextSection) {
          $('.sticky-nav__menu').removeClass('fixed');
          $('.sticky-nav__menu li').width('100%');
        }
      });
    }
  },

  // JavaScript to be fired on all pages, after page specific JS is fired
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/report.js